/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 12:09:10
 * @FilePath: \eu-eswop-official-site\src\router\index.js
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { vm } from '@/locales'
import Home from '../views/home/index.vue'
import WhoAreWe from '../views/home/whoAreWe.vue'
import Business from '../views/home/business.vue'
import PrivacyPolicy from '../views/privacyPolicy/index.vue'
import TermsAndConditions from '../views/termsAndConditions/index.vue'
import FAQs from '../views/FAQs/index.vue'
import inspectionPhotograph from '../views/upload/inspectionPhotograph.vue'
import inspectionPhotographSuccess from '../views/upload/inspectionPhotographSuccess'
import inspectionPhotographfail from '../views/upload/inspectionPhotographfail.vue'
import shippingLable from '../views/shippingLable/shippingLable.vue'
import order from '../views/order/order.vue'
import Product from '../views/product/productContainer.vue'
import Search from '../views/search/searchContainer.vue'
import Property from '../views/property/propertyContainer.vue'
import Evaluate from '../views/evaluate/evaluateContainer.vue'
import SettleAccount from '../views/settleAccount/settleAccountContainer.vue'
import SuccessOrder from '../views/successOrder/successOrder.vue'
import Protocol from '../views/protocol/protocolContainer.vue'
import blog from '../views/blog/index.vue'
import blogDetail from '../views/blog/blogDetail.vue'
import personalInfo from '../views/personalInfo/personalInfo.vue'
import cookiePrivadidad from '../views/cookiePrivadidad/cookiePrivadidad.vue'
import cookiePriva from '../views/cookiePriva/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/order'
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/home/whoAreWe',
  //   name: 'WhoAreWe',
  //   component: WhoAreWe
  // },
  // {
  //   path: '/home/business',
  //   name: 'Business',
  //   component: Business
  // },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/cookiePrivadidad',
    name: 'cookiePrivadidad',
    component: cookiePrivadidad
  }, 
  {
    path: '/cookiePriva',
    name: 'cookiePriva',
    component: cookiePriva
  }, 
  {
    path: '/termsAndConditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/FAQs',
    name: 'FAQs',
    component: FAQs
  },
  {
    path: '/product',
    name: 'Product',
    meta: { title: vm.$t("router.selectModel") }, // 选择机型
    component: Product
  },
  // {
  //   path: '/search',
  //   name: 'Search',
  //   component: Search
  // },
  // {
  //   path: '/blogList',
  //   name: 'blogList',
  //   component: blog
  // },
  // {
  //   path: '/blogDetail',
  //   name: 'BlogDetail',
  //   component: blogDetail
  // },
  // {
  //   path: '/property',
  //   name: 'Property',
  //   meta: { title: vm.$t("router.selectProperty") }, // 选择估价信息
  //   component: Property
  // },
  // {
  //   path: '/evaluate',
  //   name: 'Evaluate',
  //   meta: { title: vm.$t("router.price") }, // 预估价
  //   component: Evaluate
  // },
  // {
  //   path: '/settleAccount',
  //   name: 'SettleAccount',
  //   meta: { title: vm.$t("router.priceOrder") }, // 预估价2 信息填写
  //   component: SettleAccount
  // },
  {
    path: '/personalInfo',
    name: 'PersonalInfo',
    meta: { title: vm.$t("router.priceOrder") }, // 个人信息收集
    component: personalInfo
  },
  {
    path: '/successOrder',
    name: 'SuccessOrder',
    meta: { title: vm.$t("router.orderSuccess") }, 
    component: SuccessOrder
  },
  // {
  //   path: '/protocol',
  //   name: 'Protocol',
  //   meta: { title: 'Details' },
  //   component: Protocol
  // },
  // {
  //   path: '/inspectionPhotograph',
  //   name: 'inspectionPhotograph',
  //   component: inspectionPhotograph,
  //   meta: { qualify: true }
  // },
  // {
  //   path: '/inspectionPhotographSuccess',
  //   name: 'inspectionPhotographSuccess',
  //   component: inspectionPhotographSuccess,
  //   meta: { qualify: true }
  // },
  // {
  //   path: '/inspectionPhotographfail',
  //   name: 'inspectionPhotographfail',
  //   component: inspectionPhotographfail,
  //   meta: { qualify: true }
  // },
  {
    path: '/shippingLable',
    name: 'shippingLable',
    component: shippingLable,
    meta: { qualify: true }
  },
  {
    path: '/order',
    name: 'order',
    component: order,
    meta: { qualify: true }
  },
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  } else {
    return originalPush.call(this, location).catch(err => err)
  }
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  } else {
    return originalReplace.call(this, location).catch(err => err)
  }
}

export default router
